'use es6';

import { reduceProductsResponse } from 'pricing-pages-lib/reducers/Products';
import Raven from 'Raven';
import { FetchProductsRequestTypes } from '../actions/ProductsActions';

const AbstractedProducts = (state = {
  products: {},
  productVersions: {},
  skuMap: {},
  apiNameToProductId: {},
  productLineLevelToProductId: {},
  parcelNameToProductId: {}
}, {
  type,
  payload
}) => {
  switch (type) {
    case FetchProductsRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;

        if (!Array.isArray(data)) {
          Raven.captureException(new Error('Invalid response from Product Abstraction endpoint'), {
            extra: {
              data
            }
          });
        }

        return reduceProductsResponse(data);
      }

    default:
      return state;
  }
};

export default AbstractedProducts;